export const theme = {
  breakpoints: ["512px", "768px", "920px"],
  fontSizes: ["1rem", "1.2rem", "3rem"],
  colors: {
    textNormal: "var(--textNormal)",
    textInverse: "var(--textInverse)",
    textTitle: "var(--textTitle)",
    textTitleInverse: "var(--textTitleInverse)",
  },
}
